<template>
  <div>

    <ActionBar dismissible @dismiss="dismiss">
      <el-button v-if="!this.readonly" slot="action" type="danger" @click="reject">
          ไม่รับเติม
      </el-button>
      <el-button v-if="!this.readonly" slot="action" type="success" @click="accept">
          รับเติม
      </el-button>

      <ActionBarTitle>{{ this.title }}</ActionBarTitle>
    </ActionBar>

    <PageContainer>
      <AppContainer>

        <h1 v-if="!this.isHistory">{{this.title}}</h1>

        <Form :data="this.data" :readonly="this.readonly" @change="value=> { this.data = value}">

          <h2 slot="header">
            เติมทอง ID : {{ this.$route.params.id }}
            <StatusTag :type="this.status" :style="{ marginLeft: '0.5rem' , verticalAlign: 'middle' }" />
          </h2>

        </Form>
        eee
        <Status v-if="this.isHistory" :status="this.statusResult.status" :date="this.statusResult.date"
          :branch="this.statusResult.branch" :transferee="this.statusResult.transferee" :note="this.statusResult.note"
          :style="{ marginTop: '1.5rem' }" />

      </AppContainer>
    </PageContainer>
  </div>
</template>

<script>
import Joi from '@hapi/joi'

import {
  ActionBar,
  ActionBarTitle
} from '@/components/ui/action-bar'


import { PageContainer } from '@/components/page/page-container'
import { AppContainer } from '@/components/ui/container'
import { back } from '@/utils/navigation'
import { GoldFillService } from '@/services'
import { useLoading } from '@/use/loading'

const Form = () => import('../components/fill/Form.vue')
const Status = () => import('../components/Status.vue')
const StatusTag = () => import('../components/StatusTag.vue')

export default {
  name: 'GoldTransferFillDetail',
  components: {
    ActionBar,
    ActionBarTitle,
    Form, Status, StatusTag,
    PageContainer, AppContainer,
  },
  data() {
    return {
      status: '',
      data: {
        invoiceId: '',
        realWeight: 0,
        datetime: null,
        transferor: '',
        store: '',
        carrier: '',
        items: [],
        note: ''
      },
      statusResult: {
        status: null,
        date: null,
        branch: null,
        transferee: null,
        note: null
      }
    }
  },

  computed: {
    readonly() {
      return this.status !== 'requested'
    },

    isHistory() {
      return this.$route.meta.history
    },

    title() {
      return this.isHistory ? 'รายละเอียดรับเติมทอง' : 'รับเติมทอง'
    }
  },

  async beforeRouteEnter(to, from, next) {
    const { id } = to.params

    const loading = useLoading()

    try {
      const {
        data: { result }
      } = await GoldFillService.get(id)

      next(vm => {
        vm.status = result.status

        vm.data = {
          invoiceId: result.invoice_id,
          realWeight: +result.total_weight,
          datetime: new Date(result.datetime),
          transferor: result.user
            ? `${result.user.first_name} ${result.user.last_name}`.trim()
            : '',
          store: result.supplier_company ? result.supplier_company.name : '',
          carrier: result.carrier_name,
          items: result.items.map(item => ({
            product: item.product
              ? {
                  id: item.product.id,
                  name: item.product.name,
                  percent: item.product.purity_percentage / 100
                }
              : null,
            amount: +item.amount,
            weight: +item.baht_weight,
            realWeight: +item.real_weight
          })),
          note: result.note
        }

        vm.statusResult = {
          status: result.status,
          date: result.replied_datetime
            ? new Date(result.replied_datetime)
            : null,
          branch: result.to_branch ? result.to_branch.name : null,
          transferee: result.transferee
            ? `${result.transferee.first_name} ${result.transferee.last_name}`.trim()
            : '-',
          note: result.decline_reason
        }
      })
    } catch (e) {
      next(vm => {
        vm.$notify.error(e.message)
        back({ name: 'GoldTransfer' })
      })
    } finally {
      loading.close()
    }
  },

  created() {
    addEventListener('beforeunload', this.handleBeforeunload)
  },

  beforeDestroy() {
    removeEventListener('beforeunload', this.handleBeforeunload)
  },


  methods: {

    //--- Close the page ---
    dismiss() {
      back({ name: 'GoldTransfer' })
    },

    //--- click reject button ----
    reject() {
      const { id } = this.$route.params

      const sendData = value =>
        GoldFillService.decline(id, {
          decline_reason: value
        })

      this.$msgbox({
        message: (
          <div>
            <div
              style={{
                textAlign: 'center',
                fontSize: '1.25rem',
                fontWeight: 'bold',
                margin: '1rem 0'
              }}
            >
              <p
                style={{
                  lineHeight: '1.5',
                  marginBottom: '1rem',
                  color: '#f56c6c'
                }}
              >
                ไม่รับเติมทอง
              </p>
              <p style={{ lineHeight: '1.5', marginBottom: '1rem' }}>
                ID: {this.$route.params.id}
              </p>
            </div>
            <p style={{ fontWeight: 'bold' }}>ระบุเหตุผล</p>
          </div>
        ),
        customClass: this.$style.messageBox,
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        confirmButtonClass: this.$style.messageBoxButton,
        cancelButtonText: 'ยกเลิก',
        cancelButtonClass: this.$style.messageBoxButton,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showInput: true,
        inputType: 'textarea',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            const oldConfirmButtonText = instance.confirmButtonText

            instance.confirmButtonLoading = true
            instance.confirmButtonText = 'Loading...'

            try {
              await sendData(instance.inputValue)

              done()
            } catch (e) {
              this.$notify.error(e.message)
            } finally {
              setTimeout(() => {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = oldConfirmButtonText
              }, 300)
            }
          } else {
            done()
          }
        }
      }).then(() => {
        this.$notify.success('บันทึกเรียบร้อยแล้ว')

        back({ name: 'GoldTransfer' })
      })
    },

    //--- click accept button ----
    async accept() {
      const { id } = this.$route.params

      const validate = () => {
        const schema = Joi.array()
          .items(
            Joi.object({
              product: Joi.object(),
              amount: Joi.number(),
              weight: Joi.number(),
              realWeight: Joi.number()
            })
          )
          .min(1)

        return schema.validateAsync(this.data.items, { allowUnknown: true })
      }

      const sendData = async () => {
        const data = {
          note: this.data.note,
          items: this.data.items.map(item => ({
            product: item.product.id,
            amount: item.amount,
            baht_weight: item.weight,
            real_weight: item.realWeight
          }))
        }

        const {
          data: { result }
        } = await GoldFillService.accept(id, data)

        return result.id
      }

      const showMessage = id =>
        new Promise(resolve =>
          this.$msgbox({
            message: (
              <div
                style={{
                  margin: '1rem 0',
                  textAlign: 'center',
                  fontWeight: 'bold'
                }}
              >
                <p
                  style={{
                    marginBottom: '1rem',
                    fontSize: '1.25rem',
                    lineHeight: '1.5'
                  }}
                >
                  บันทึกรับเติมทองเสร็จเรียบร้อย
                </p>
                <p
                  style={{
                    marginBottom: '1rem',
                    fontSize: '1.125rem',
                    lineHeight: '1.5'
                  }}
                >
                  ID : {id}
                </p>
              </div>
            ),
            customClass: this.$style.messageBox,
            confirmButtonClass: this.$style.messageBoxButton
          }).finally(() => {
            resolve()
          })
        )

      try {
        await validate()

        const loading = useLoading()

        try {
          const id = await sendData()

          loading.close()

          await showMessage(id)

          back({ name: 'GoldTransfer' })
        } catch (e) {
          this.$notify.error(e.message)
        } finally {
          loading.close()
        }
      } catch (e) {
        this.$message.warning('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
      }
    },

    handleBeforeunload(e) {
      e.preventDefault()
      e.returnValue = ''
    }
  },


}
</script>

<style lang="scss" module>
.messageBox {
  :global(.el-textarea__inner) {
    min-height: calc(6em + 12px) !important;
  }

  :global(.el-message-box__btns) {
    display: flex;
    justify-content: center;
  }
}

.messageBoxButton {
  font-size: 0.875rem;
  padding: 0.75rem 1.25rem;
}
</style>
